import { OctTable } from '@oceantech/oceantech-ui';
import { XMLParser } from 'fast-xml-parser';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { CODE, overflowHiddenTable } from '../../../utils/Constant';
import { usePhanHeBaoHiemYTeContext } from '../../contexts';
import { getXmlData } from '../../services';
import PrimaryInfo from '../patient-info/PrimaryInfo';
import { XML_ERROR_COLUMN, XML_TAB_CONFIG } from '../xml-preview/constants';

const CheckInPreview = () => {
	const { patientInfo } = usePhanHeBaoHiemYTeContext();

	const [tableConfig, setTableConfig] = useState<{
		data: any[];
		columns: any[];
	}>({
		data: [],
		columns: [],
	});

	useEffect(() => {
		if (patientInfo?.patientCode) {
			getXMLCheckInData({
				patientCode: patientInfo?.patientCode,
				visitCode: patientInfo?.visitCode,
			});
		}
	}, [patientInfo?.patientCode]);

	const getXMLCheckInData = async (params: any) => {
		try {
			const { code, data } = await getXmlData(XML_TAB_CONFIG['XML0'].code, params);

			if (CODE.SUCCESS === code && data) {
				const parser = new XMLParser({ ignoreAttributes: false, parseTagValue: false });
				const jsonObject = parser.parse(data);

				const columns = Object.keys(getValueFromUrl(jsonObject)?.[0])?.map(
					(item: string, index: number) => ({
						name: item?.replace(/^\w/, (c) => c.toUpperCase()),
						field: item,
						cellStyle: {
							minWidth: '100px',
							maxWidth: 'fit-content',
							...overflowHiddenTable,
							...(!index && { paddingLeft: '10px' }),
						},
					})
				);
				const tableData = getValueFromUrl(jsonObject)?.map((item: any, index: number) => ({
					...item,
					id: index,
				}));
				setTableConfig({
					data: tableData,
					columns: [...columns, ...XML_ERROR_COLUMN],
				});
			}
		} catch (error) {
			console.error(error);
		}
	};

	const getValueFromUrl = (data: any) => {
		let arrKey = XML_TAB_CONFIG['XML0'].urlData?.split('.');
		let result = arrKey.reduce((key: any, item: any) => key[item], data);
		return Array.isArray(result) ? result : [result];
	};

	return (
		<div className="bg-white d-flex flex-column h-100">
			<div className="flex-column-auto">
				<PrimaryInfo showAction={false} />
			</div>

			<div className="flex-column-fluid overflow-auto spaces h-calc-vh-200">
				<OctTable
					className="h-100 table-background-th"
					data={tableConfig.data}
					columns={tableConfig.columns ?? []}
					notDelete={true}
					notEdit={false}
					noToolbar={true}
					fixedColumnsCount={-1}
					isShowSelection={false}
					clearToolbar={true}
					noPagination
					headerClasses="xml-table-view-header"
					bodyClasses="xml-table-view-body"
				/>
			</div>

			<div className="flex-column-auto spaces pt-2 min-h-56 shadow-sm">
				<Button className="btn-fill">Gửi lại Check-in</Button>
			</div>
		</div>
	);
};

export default CheckInPreview;
